import { useEffect, useState } from "react";

const CHAPTERS = [
  { id: "chapter-i", numeral: "I", label: "The Navy" },
  { id: "chapter-ii", numeral: "II", label: "Career" },
  { id: "chapter-iii", numeral: "III", label: "The World" },
];

// Fixed right-hand chapter navigation — the book's "spine" (desktop only)
export default function ChapterSpine() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    let ticking = false;
    const apply = () => {
      const probeY = window.innerHeight * 0.4;
      let current = null;
      for (const c of CHAPTERS) {
        const el = document.getElementById(c.id);
        if (el && el.getBoundingClientRect().top <= probeY) current = c.id;
      }
      setActive(current);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        apply();
        ticking = false;
      });
    };
    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className="hidden lg:flex fixed right-5 top-1/2 -translate-y-1/2 z-40 flex-col items-center"
      aria-label="Chapter navigation"
      data-testid="chapter-spine"
    >
      <span className="w-px h-10 bg-[var(--c-border)]" aria-hidden="true" />
      {CHAPTERS.map((c) => (
        <a
          key={c.id}
          href={`#${c.id}`}
          title={c.label}
          className="group flex flex-col items-center py-2.5"
          data-testid={`spine-${c.id}`}
        >
          <span
            className={`font-serif-grand font-semibold italic text-base leading-none transition-colors duration-300 ${
              active === c.id
                ? "text-[var(--c-accent)]"
                : "text-[var(--c-text-muted)] opacity-60 group-hover:opacity-100 group-hover:text-[var(--c-text)]"
            }`}
          >
            {c.numeral}
          </span>
          <span
            className={`mt-1.5 w-1.5 h-1.5 rounded-full transition-colors duration-300 ${
              active === c.id
                ? "bg-[var(--c-accent)]"
                : "bg-[var(--c-border)] group-hover:bg-[var(--c-text-muted)]"
            }`}
          />
        </a>
      ))}
      <span className="w-px h-10 bg-[var(--c-border)]" aria-hidden="true" />
    </nav>
  );
}
